export default __webpack_public_path__ + "static/media/logo-dark-backgrounds.4212639a.svg";